import {
    ClearBoxWrapper,
    ContentWrapper,
    ResponsiveWhiteBox,
} from '@/src/modules/account/AccountStyledComponents'
import Card from '@/src/common/components/marketing/cards/Card'
import PostItNote from '@/src/common/components/marketing/cards/PostItNote'
import GiftInfoBox from '@/src/modules/account/received/GiftInfoBox'
import RedemptionOptions from '@/src/modules/account/received/RedemptionOptions'
import RedemptionHistory from '@/src/modules/pg-plus/redemption/gift-details/RedemptionHistory'
import {
    CARD_TO_CARD_ACTION_TYPE_EGIFT_CREATED,
    MEDIUM_TYPE_VIRTUAL,
} from '@/prisma/schemaConstants'
import { IGift } from '@/src/common/queries/FetchReceivedGiftDetails'
import { PostItWrapper } from '@/src/modules/pg-plus/PGPlusStyledComponents'
import WrappedCard from '@/src/common/components/marketing/cards/WrappedCard'
import PGPlusCardOverlay from '@/src/modules/pg-plus/content/PGPlusCardOverlay'
import { currencyFormatter } from '@/src/common/utilities/currencyFormatter'

interface IGiftDetails {
    data: IGift
    refetchGift: Function
    margin?: 'default' | 'none'
}

const GiftDetailsDisplay = ({
    data: giftData,
    refetchGift,
    margin = 'default',
}: IGiftDetails) => {
    const {
        card_image,
        sender_name,
        medium_type,
        card_link,
        denomination,
        is_pg_plus,
    } = giftData

    const wrapperImage = giftData?.wrapper_image
    const giftMessage = giftData?.gift_message
    const history = giftData?.event_log ?? []
    const redemptionMethod = giftData?.redemption_method
    const redemptionOptions = giftData?.redemption_options ?? {
        brand_change_allowed: false,
        redeemable_via_egift: false,
        redeemable_via_plastic: false,
        redeemable_via_card_link: false,
    }
    const plasticExchangeEligible = giftData?.plastic_exchange_eligible ?? false
    const hasBeenCardLinked: boolean = !!card_link?.last_four

    const isEgift: boolean =
        redemptionMethod === CARD_TO_CARD_ACTION_TYPE_EGIFT_CREATED
    const isVirtualVisa: boolean =
        !redemptionMethod && medium_type === MEDIUM_TYPE_VIRTUAL

    const canRedeemOrExchange: boolean =
        redemptionOptions.brand_change_allowed ||
        redemptionOptions.redeemable_via_egift ||
        redemptionOptions?.redeemable_via_plastic ||
        plasticExchangeEligible

    const denomInDollars = currencyFormatter(denomination)
    const overlay = is_pg_plus ? 'pg-plus' : 'none'

    return (
        <>
            <ContentWrapper margin={margin}>
                <ResponsiveWhiteBox>
                    {wrapperImage ? (
                        <WrappedCard
                            brandImage={card_image}
                            wrapperImage={wrapperImage}
                            swipeToOpen={true}
                        >
                            <PGPlusCardOverlay
                                value={denomInDollars}
                                isPgPlus={is_pg_plus}
                                isWrapped={true}
                            />
                        </WrappedCard>
                    ) : (
                        <Card
                            size={'lg'}
                            image={card_image}
                            isExtended={false}
                            overlayType={overlay}
                            showLoader={!card_image}
                            value={denomInDollars}
                        />
                    )}
                    {!!giftMessage && (
                        <PostItWrapper>
                            <PostItNote
                                postItText={giftMessage}
                                nameText={sender_name}
                            />
                        </PostItWrapper>
                    )}
                    {/*<SocialShareIcons*/}
                    {/*    facebookUrl={'https://www.facebook.com/PerfectGiftCom'}*/}
                    {/*    twitterUrl={'https://twitter.com/PerfectGiftcom'}*/}
                    {/*    instagramUrl={*/}
                    {/*        'https://www.instagram.com/perfectgiftcom/'*/}
                    {/*    }*/}
                    {/*    linkedinUrl={*/}
                    {/*        'https://www.linkedin.com/company/perfectgiftcom/'*/}
                    {/*    }*/}
                    {/*    iconColor={'secondary'}*/}
                    {/*    size={'md'}*/}
                    {/*    justifyContent={'center'}*/}
                    {/*    gap={'large'}*/}
                    {/*/>*/}
                </ResponsiveWhiteBox>
                <ClearBoxWrapper>
                    <GiftInfoBox
                        giftData={giftData}
                        refetchGift={refetchGift}
                    />
                    {canRedeemOrExchange && (
                        <RedemptionOptions
                            redemptionOptions={redemptionOptions}
                            isVirtualVisa={isVirtualVisa}
                            isEgift={isEgift}
                            plastic_exchange_eligible={plasticExchangeEligible}
                            refetchGift={refetchGift}
                            hasBeenCardLinked={hasBeenCardLinked}
                        />
                    )}
                </ClearBoxWrapper>
            </ContentWrapper>
            {history && (
                <RedemptionHistory history={history} showHelpButtons={true} />
            )}
        </>
    )
}

export default GiftDetailsDisplay
